import { Skeleton } from '@/shared/components/ui/skeleton'

export function ProposalFormSkeleton() {
  return (
    <div className="mx-auto mb-4 max-w-6xl px-6 py-4">
      <div className="mb-8 text-center">
        <Skeleton className="mb-2 h-10 w-3/4 w-full" />
      </div>
      <div className="mb-8 text-center">
        <Skeleton className="mb-2 h-6 w-3/4 max-w-md" />
        <Skeleton className="h-4 w-2/4 max-w-sm" />
      </div>
      <div className="flex flex-wrap gap-6">
        <div className="flex min-h-70 min-w-full flex-col gap-4 rounded-lg border p-6 shadow-sm md:min-w-85">
          <div className="mb-4 flex">
            <Skeleton className="h-8 w-8 rounded-full" />
          </div>
          <Skeleton className="mb-2 h-5 w-3/4" />
          <Skeleton className="mb-4 h-4 w-1/2" />
          <Skeleton className="mt-4 h-10 w-full rounded-md" />
        </div>
        <div className="flex min-h-70 min-w-full flex-col gap-4 rounded-lg border p-6 shadow-sm md:min-w-85">
          <div className="mb-4 flex">
            <Skeleton className="h-8 w-8 rounded-full" />
          </div>
          <Skeleton className="mb-2 h-5 w-3/4" />
          <Skeleton className="mb-4 h-4 w-1/2" />
          <Skeleton className="mt-4 h-10 w-full rounded-md" />
        </div>
        <div className="flex min-h-70 min-w-full flex-col gap-4 rounded-lg border p-6 shadow-sm md:min-w-85">
          <div className="mb-4 flex">
            <Skeleton className="h-8 w-8 rounded-full" />
          </div>
          <Skeleton className="mb-2 h-5 w-3/4" />
          <Skeleton className="mb-4 h-4 w-1/2" />
          <Skeleton className="mt-4 h-10 w-full rounded-md" />
        </div>
      </div>
      <div className="mt-12 flex justify-end">
        <Skeleton className="h-10 w-32 rounded-md" />
      </div>
    </div>
  )
}
